$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".hk-play-button", function (e) {
     var video = jQuery(this).parents('.hk-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.hk-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.hk-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});





$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});




$(document).on("click", ".hk-mobile-menu-button", function (e) {
    $('.hk-drawer-menu').addClass('active');
    $('.hk-drawer-menu-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-menu-close", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

$(document).on("click", ".hk-drawer-menu-bg", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});



$(document).on("click", ".hk-element-variant", function(e) {
$('.hk-element-variant').removeClass('hk-active');
$(this).addClass('hk-active');
var variant_id = $(this).attr('variant_id');
$(this).parents('.hk-product').find('.hk-variant-trigger').hide().removeClass('.hk-active');
$(this).parents('.hk-product').find('.hk-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('.hk-active');
$('.hk-checkout-button').attr('variant_id',variant_id);
$('.hk-element-option').attr('variant_id',variant_id);
$('.hk-variant-trigger[variant_id="'+variant_id+'"]').find('.slick-slider').each(function () {
if ($(this).hasClass('slick-initialized')) {
$(this).slick('refresh');
}
});
});



$(document).on("click", ".hk-element-option", function(e) {
$('.hk-element-option').removeClass('hk-active');
$(this).addClass('hk-active');
var quantity = $(this).attr('quantity');
var data_tab = $(this).attr('data_tab');
var selling_plan = $(this).attr('selling_plan');
var label = $(this).attr('label');
var variant_id = $(this).attr('variant_id');
$('.hk-checkout-button').attr('variant_id',variant_id);
$(this).parents('.hk-product').find('.hk-quantity-trigger').hide().removeClass('.hk-active');
$(this).parents('.hk-product').find('.hk-quantity-trigger[data_tab="'+data_tab+'"]').show().addClass('.hk-active');
$('.hk-checkout-button').attr('quantity',quantity);
$('select.hk-sub-select strong').eq(0).text(label);
$('.hk-checkout-button').attr('selling_plan',selling_plan);
});


$(document).on("click", ".hk-element-sub-option", function(e) {
$('.hk-element-sub-option').removeClass('hk-active');
$(this).addClass('hk-active');
var sub_tab = $(this).attr('sub_tab');
var selling_plan = $(this).attr('selling_plan');
$(this).parents('.hk-product').find('.hk-sub-trigger').hide().removeClass('.hk-active');
$(this).parents('.hk-product').find('.hk-sub-trigger[sub_tab="'+sub_tab+'"]').show().addClass('.hk-active');
if (sub_tab == '1'){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}
});

$(document).on("change", "select.hk-sub-select", function(e) {
var selling_plan = $(this).val();
$('.hk-element-sub-option[sub_tab="1"]').attr('selling_plan',selling_plan);
$('.hk-checkout-button').attr('selling_plan',selling_plan);
});


$(document).on("click", ".hk-pdp-ingrediente-tabs-item", function(e) {
$('.hk-pdp-ingrediente-tabs-item').removeClass('hk-active');
$(this).addClass('hk-active');
var index = $(this).index();
var img_index = index+1;
$('.hk-pdp-ingrediente-list1-item').removeClass('hk-active');
$('.hk-pdp-ingrediente-list1-item').eq(index).addClass('hk-active');
$('.hk-pdp-ingrediente-img').removeClass('hk-active');
$('.hk-pdp-ingrediente-img'+img_index).addClass('hk-active');
});





function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.hk-pdp-result-list1-item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('hk-active');
        } else {
          $(this).removeClass('hk-active');
        }
    });
});




  $(document).on("click", '.hk-atc-js', function (e) {
  e.preventDefault();
  var $btn = $(this);
  if ($btn.hasClass('hk-loading')) return;
  $btn.addClass('hk-loading');
  var items = [];
  // main product
  var variant_id = $btn.attr('variant_id');
  var item = {
    id: parseInt(variant_id),
    quantity: 1
  };
  items.push(item);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',
    success: function () {
    },
    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
        document.querySelector('a.cart-drawer-button')?.click();
      }, 500);
    }
  });

});


$(document).on("click", "a[href='#popup']", function(e) {
  e.preventDefault();
var target = $(this).parents('.hk-element-text').attr('target');
$('.hk-popup[target="'+target+'"]').addClass('hk-active');
});
$(document).on("click", ".hk-close-popup,.hk-popup-bg", function(e) {
  e.preventDefault();
$('.hk-popup').removeClass('hk-active');
});


$(document).on("click", ".hk-upsell-toggle", function(e) {
$(this).toggleClass('hk-active');
});





$(document).on("click", "a[href='#popup2']", function(e) {
  e.preventDefault();
$('.hk-pdp-popup').addClass('hk-active');
});
$(document).on("click", ".hk-pdp-poup-close,.hk-pdp-popup-bg", function(e) {
  e.preventDefault();
$('.hk-pdp-popup').removeClass('hk-active');
});